module.exports = __webpack_public_path__ + "static/media/medical-history.7fff8cc8.png";